import { ContentType } from './constants';

export function getType(contentType: string, isImage: boolean): ContentType {
  if (isImage) return ContentType.IMAGE;
  if (contentType.includes('pdf')) return ContentType.PDF;
  if (contentType.includes('svg')) return ContentType.SVG;
  return ContentType.OTHER;
}
